module.exports = __webpack_public_path__ + "poster4.png";


//////////////////
// WEBPACK FOOTER
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/assets/poster4.png
// module id = 1134
// module chunks = 10